var _defineProperty = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _toConsumableArray = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Users/Bas/repos/projects/catafolk/website/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-env browser */
var _require = require('buffer/'),
    Buffer = _require.Buffer;

function syncFetch() {
  var _parseArgs = parseArgs.apply(void 0, arguments),
      _parseArgs2 = _slicedToArray(_parseArgs, 2),
      url = _parseArgs2[0],
      opts = _parseArgs2[1];

  var xhr = new XMLHttpRequest();
  xhr.withCredentials = opts.credentials === 'include';
  xhr.timeout = opts.timeout; // Request

  xhr.open(opts.method || 'GET', url, false);

  try {
    xhr.responseType = 'arraybuffer';
  } catch (e) {// not in Worker scope
    // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseType#Synchronous_XHR_restrictions
  }

  var _iterator = _createForOfIteratorHelper(opts.headers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var header = _step.value;
      xhr.setRequestHeader.apply(xhr, _toConsumableArray(header));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  xhr.send(opts.body || null); // Response

  var headers = xhr.getAllResponseHeaders();
  headers = headers && headers.split('\r\n').filter(Boolean).map(function (header) {
    return header.split(': ', 2);
  });
  return new syncFetch.Response(xhr.response, {
    url: xhr.responseURL,
    status: xhr.status,
    statusText: xhr.statusText,
    headers: headers,
    redirected: xhr.responseURL !== url
  });
}

function parseArgs(resource, init) {
  var request = [];

  if (resource instanceof syncFetch.Request) {
    request.push(resource.url);
    request.push({
      method: resource.method,
      headers: resource.headers,
      body: resource.body
    });
  } else {
    request.push(resource, {});
  }

  Object.assign(request[1], init);
  request[1].headers = new syncFetch.Headers(request[1].headers || {});
  return request;
}

var INTERNALS = Symbol('SyncFetch Internals');

var SyncRequest = /*#__PURE__*/function (_Request) {
  "use strict";

  _inherits(SyncRequest, _Request);

  var _super2 = _createSuper(SyncRequest);

  function SyncRequest(resource) {
    var _this;

    var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : init.body;

    _classCallCheck(this, SyncRequest);

    _this = _super2.call(this, resource, init);
    _this[INTERNALS] = {
      body: body ? Buffer.from(body) : null
    };
    return _this;
  }

  _createClass(SyncRequest, [{
    key: "clone",
    value: function clone() {
      checkBody(this);
      return new SyncRequest(this.url, this);
    }
  }]);

  return SyncRequest;
}( /*#__PURE__*/_wrapNativeSuper(Request));

var SyncResponse = /*#__PURE__*/function (_Response) {
  "use strict";

  _inherits(SyncResponse, _Response);

  var _super3 = _createSuper(SyncResponse);

  function SyncResponse(body) {
    var _this2;

    var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SyncResponse);

    body = body ? Buffer.from(body) : null;
    _this2 = _super3.call(this, createStream(body), init);
    _this2[INTERNALS] = {
      url: init.url,
      redirected: init.redirected,
      body: body
    };
    return _this2;
  }

  _createClass(SyncResponse, [{
    key: "clone",
    value: function clone() {
      checkBody(this);
      return new SyncResponse(this[INTERNALS].body, {
        url: this.url,
        headers: this.headers,
        status: this.status,
        statusText: this.statusText,
        redirected: this.redirected
      });
    }
  }, {
    key: "url",
    get: function get() {
      return this[INTERNALS].url;
    }
  }, {
    key: "redirected",
    get: function get() {
      return this[INTERNALS].redirected;
    }
  }]);

  return SyncResponse;
}( /*#__PURE__*/_wrapNativeSuper(Response));

var Body = /*#__PURE__*/function () {
  "use strict";

  function Body(body) {
    _classCallCheck(this, Body);

    this[INTERNALS] = {
      body: Buffer.from(body)
    };
  }

  _createClass(Body, [{
    key: "arrayBuffer",
    value: function arrayBuffer() {
      checkBody(this);
      var buffer = consumeBody(this);
      return buffer.buffer.slice(buffer.byteOffset, buffer.byteOffset + buffer.byteLength);
    }
  }, {
    key: "blob",
    value: function blob() {
      checkBody(this);
      var type = this.headers && this.headers.get('content-type');
      return new Blob([consumeBody(this)], type && {
        type: type
      });
    }
  }, {
    key: "text",
    value: function text() {
      checkBody(this);
      return consumeBody(this).toString();
    }
  }, {
    key: "json",
    value: function json() {
      checkBody(this);

      try {
        return JSON.parse(consumeBody(this).toString());
      } catch (err) {
        throw new TypeError("invalid json response body at ".concat(this.url, " reason: ").concat(err.message), 'invalid-json');
      }
    }
  }, {
    key: "buffer",
    value: function buffer() {
      checkBody(this);
      return consumeBody(this).clone();
    }
  }], [{
    key: "mixin",
    value: function mixin(prototype) {
      var _iterator2 = _createForOfIteratorHelper(Object.getOwnPropertyNames(Body.prototype)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var name = _step2.value;

          if (name === 'constructor') {
            continue;
          }

          var desc = Object.getOwnPropertyDescriptor(Body.prototype, name);
          Object.defineProperty(prototype, name, _objectSpread(_objectSpread({}, desc), {}, {
            enumerable: true
          }));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return Body;
}();

function checkBody(body) {
  if (body.bodyUsed) {
    throw new TypeError("body used already for: ".concat(body.url));
  }
}

function consumeBody(body) {
  _super(body, 'arrayBuffer')();

  return body[INTERNALS].body || Buffer.alloc(0);
}

function _super(self, method) {
  return Object.getPrototypeOf(Object.getPrototypeOf(self))[method].bind(self);
}

function createStream(body) {
  return new ReadableStream({
    start: function start(controller) {
      controller.enqueue(body);
      controller.close();
    }
  });
}

Body.mixin(SyncRequest.prototype);
Body.mixin(SyncResponse.prototype);
syncFetch.Headers = self.Headers;
syncFetch.Request = SyncRequest;
syncFetch.Response = SyncResponse;
module.exports = syncFetch;